import PropTypes from 'prop-types';

const AccountSetError = ({ touched, errors, accountSetIndex }) => {
  const showError =
    touched?.accountSets?.length > 0 &&
    touched.accountSets[accountSetIndex] &&
    errors?.accountSets?.length > 0 &&
    typeof errors.accountSets[accountSetIndex] === 'string';

  if (showError) {
    return (
      <tr className="gl-accountset-error">
        <td colSpan={7}>{errors.accountSets[accountSetIndex]}</td>
      </tr>
    );
  }
  return null;
};

AccountSetError.propTypes = {
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  accountSetIndex: PropTypes.number.isRequired,
};

export default AccountSetError;
